import { computed, defineComponent } from 'vue';
import { withInstall } from '../_util/type';
import useConfigInject from '../_util/hooks/useConfigInject';
export const iconProps = () => ({
    iconClass: {
        type: String,
        default: '',
    },
    color: {
        type: String,
        default: '',
    },
    class: {
        type: String,
        default: '',
    },
    onClick: {
        type: Function,
    },
    onMousedown: {
        type: Function,
    },
});
const Icon = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdIcon',
    props: iconProps(),
    setup(props) {
        const { prefixCls: prefixClsRef } = useConfigInject('icon', props);
        const iconName = computed(() => `#${props.iconClass}`);
        const color = computed(() => props.color);
        const classString = computed(() => {
            // const prefixCls = prefixClsRef.value;
            return {
                // [prefixCls]: true,
                [props.class]: true,
                wdicon: true,
            };
        });
        return () => {
            return (<span onClick={props.onClick} onMousedown={props.onMousedown} class={classString.value}>
          <svg class={prefixClsRef.value} aria-hidden="true">
            <use href={iconName.value} xlinkHref={iconName.value} fill={color.value}/>
          </svg>
        </span>);
        };
    },
});
export default withInstall(Icon);
